import { CONSTELLATION_MEDIA_FILTERS } from '@/app/constellationPro/constants';
import { SOURCES } from '@/app/library/composables/useMediaSources';
import { LIBRARY_SCOPED_FILTERS } from '@/app/library/constants';
import { constants } from '@/config';

const App = () => import('@/app/constellationPro/App.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const MediaLibrary = () => import('@/app/library/pages/MediaLibrary.vue');
const Overview = () => import('@/app/constellationPro/pages/Overview.vue');

const PAGE_LEVEL_TOP = 'Constellation Pro';

export default {
  path: 'constellation-pro',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'constellation-pro',
      path: '',
      redirect: { name: 'constellation-pro.overview' },
    },
    {
      name: 'constellation-pro.overview',
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'constellation-pro.boards',
      path: 'boards',
      component: BoardsIndex,
      props: {
        galleryType: constants.AI_GENERATION,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Projects`,
      },
    },
    {
      name: 'constellation-pro.library',
      path: 'library',
      component: MediaLibrary,
      props: {
        pageTitle: 'Constellation Library',
        scope: LIBRARY_SCOPED_FILTERS.CONSTELLATION_MEDIA.scope,
        visibleFilters: CONSTELLATION_MEDIA_FILTERS,
        excludedSources: [SOURCES.OWNED.value, SOURCES.UGC.value, SOURCES.COMPETITIVE.value],
        includeAiGenerated: true,
        includeAiGeneratedSource: true,
        openDrawerName: 'AiAlternativePreview',
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Library`,
      },
    },
  ],
};
